
import page from "~/layouts/blog.vue";

export default {
  components: {
    page,
  },

  head() {
    return {
      title:
        "Outils pour créer un site Internet gratuitement : sont-ils efficaces ?",
      meta: [
        {
          hid: "description",
          name: "description",
          content:
            "Un site Internet gratuit, sans ligne de code informatique et en quelques heures. La promesse peut trouver oreille attentive chez les entreprises au budget limité.",
        },
        {
          hid: "og:title",
          property: "og:title",
          content:
            "Outils pour créer un site Internet gratuitement : sont-ils efficaces ?",
        },
        {
          hid: "og:description",
          property: "og:description",
          content:
            "Un site Internet gratuit, sans ligne de code informatique et en quelques heures. La promesse peut trouver oreille attentive chez les entreprises au budget limité.",
        },
      ],
    };
  },
};
